export const iconFontAwesomeMaritimeFish = (
	<i className="fa-solid fa-fish"></i>
);
